import styled from 'styled-components';

export const Content = styled.div`
  textarea {
    border: 1px solid var(--color-border);

    &:hover,
    &:focus {
      box-shadow: none;
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }
`;
